var FS = /** @class */ (function () {
    function FS() {
    }
    return FS;
}());
export { FS };
